// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"6a602d67","234":"93e1457b","784":"581bea3f","889":"5ac5af0c"}[chunkId] + ".chunk.css";
};